import domReady from '@wordpress/dom-ready';
import manifest from '../manifest.json';

domReady(async () => {
	const blockJsClass = manifest.blockJsClass;
	const desktopMediaQuery = '(min-width: 1024px)';
	const mediaQueryList = window.matchMedia(desktopMediaQuery);

	const priceComparisonTableNewElement = document.querySelector(`.${blockJsClass}`);

	if (!priceComparisonTableNewElement) {
		return;
	}

	const priceComparisonTableNewDesktopElement = priceComparisonTableNewElement.querySelector(`.${blockJsClass}-desktop`) ?? '';
	const priceComparisonTableNewMobileElement = priceComparisonTableNewElement.querySelector(`.${blockJsClass}-mobile`);

	if (!priceComparisonTableNewMobileElement && !priceComparisonTableNewDesktopElement) {
		return;
	}

	const { Tippy } = await import('./tippy');
	const { PricePicker } = await import('./price-picker');
	const { MonthYearToggle } = await import('./month-year-toggle');
	const { MatchHeights } = await import('./match-heights');
	const { AlternateButtons } = await import('./alternate-buttons');
	const { FeatureAlternateTier } = await import('./feature-alternate-tier');
	const { CustomModalRedirect } = await import('./custom-modal-redirect');

	const { MobileFeatureDropdowns } = await import('./mobile-feature-dropdowns');

	if (priceComparisonTableNewElement) {
		const sharedComponents = [
			new PricePicker({ element: priceComparisonTableNewElement, blockJsClass }),
			new MonthYearToggle({
				element: priceComparisonTableNewElement,
				blockJsClass,
			}),
			new AlternateButtons({ element: priceComparisonTableNewElement, blockJsClass }),
			new FeatureAlternateTier({ element: priceComparisonTableNewElement, blockJsClass }),
			new CustomModalRedirect({ element: priceComparisonTableNewElement }),
		];

		sharedComponents.forEach((component) => component.init());

		let desktopComponentsInitialized = false;
		let mobileComponentsInitialized = false;

		const initializeDesktopComponents = () => {
			if (desktopComponentsInitialized || !priceComparisonTableNewDesktopElement) {
				return;
			}

			const desktopComponents = [
				new Tippy({ element: priceComparisonTableNewElement, blockJsClass }),
				new MatchHeights({
					element: priceComparisonTableNewElement,
					blockJsClass,
					types: ['features-heading', 'tier-description'],
					desktopMediaQuery,
				}),
			];

			desktopComponents.forEach((component) => component.init());
			desktopComponentsInitialized = true;
		};

		const initializeMobileComponents = () => {
			if (mobileComponentsInitialized || !priceComparisonTableNewMobileElement) {
				return;
			}

			const mobileComponents = [
				new MobileFeatureDropdowns({
					element: priceComparisonTableNewMobileElement,
					blockJsClass: `${blockJsClass}-mobile`,
				}),
			];

			mobileComponents.forEach((component) => component.init());
			mobileComponentsInitialized = true;
		};

		const syncBreakpointComponents = () => {
			if (mediaQueryList.matches) {
				initializeDesktopComponents();

				return;
			}

			initializeMobileComponents();
		};

		syncBreakpointComponents();

		if (mediaQueryList.addEventListener) {
			mediaQueryList.addEventListener('change', syncBreakpointComponents);
		} else {
			mediaQueryList.addListener(syncBreakpointComponents);
		}
	}
});
